import { useMemo } from 'react';
import { View, ActivityIndicator, useWindowDimensions } from 'react-native-web';

import PageNumberNav from '../PageNumberNav';
import getResultsWithLabels from '../../utilities/getResultsWithLabels';
import useDiscoverStore from '../../../../zustand-stores/DiscoverStore';
import { useDiscoverResults, useProgramResultCards } from '../../hooks';

import responsiveStyles from '../../styles';

const DiscoverResults = () => {
  const layout = useWindowDimensions();
  const styles = responsiveStyles(layout, 695);

  const { count, loading, results, fetchPageResults } = useDiscoverResults();

  const { isDaily, subView, shouldSeePricesWithFees } = useDiscoverStore(store => ({
    isDaily: store.isDaily,
    subView: store.subView,
    shouldSeePricesWithFees: store.shouldSeePricesWithFees,
  }));

  const resultsMemo = useMemo(() => getResultsWithLabels(results), [results]);
  const resultCards = useProgramResultCards(isDaily, subView, shouldSeePricesWithFees, resultsMemo);

  return (
    <View style={[styles('container'), styles('resultsContainer')]}>
      {!loading && resultCards ? (
        <>
          {resultCards}
          <PageNumberNav count={count} fetchPageResults={fetchPageResults} />
        </>
      ) : (
        <ActivityIndicator />
      )}
    </View>
  );
};

export default DiscoverResults;
